import { ViewConfig } from "@lib/views";
import { DocumentCategoryColumn } from "@common/types/views/documentCategoriesView";
import { DocumentCategoryRow } from "./utils";
import { NameCell } from "./Cells/NameCell";
import { DescriptionCell } from "./Cells/DescriptionCell";
import { PercentageCell } from "./Cells/PercentageCell";
import { DocumentsCell } from "./Cells/DocumentsCell";
import { ActionsCell } from "./Cells/ActionsCell";

export const createDocumentCategoriesViewConfig = (): ViewConfig<
    DocumentCategoryRow,
    DocumentCategoryColumn,
    never
> => ({
    columns: {
        [DocumentCategoryColumn.NAME]: {
            accessorKey: "label",
            name: "Document category",
            header: "Document category",
            immutable: true,
            cell: NameCell,
            minSize: 200,
            maxSize: 600,
        },
        [DocumentCategoryColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Category description",
            header: "Category description",
            cell: DescriptionCell,
            minSize: 200,
            maxSize: 800,
        },
        [DocumentCategoryColumn.PERCENTAGE]: {
            accessorKey: "percentage",
            name: "%",
            header: "%",
            cell: PercentageCell,
            minSize: 80,
            maxSize: 100,
        },
        [DocumentCategoryColumn.DOCUMENTS]: {
            accessorKey: "documentsCount",
            name: "Documents",
            header: "Documents",
            cell: DocumentsCell,
            minSize: 100,
            maxSize: 140,
        },
        [DocumentCategoryColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
            minSize: 60,
            maxSize: 60,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: DocumentCategoryColumn.NAME,
        childrenKey: "children",
    },
});
